import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";

const state = {
    marketData: null,
};

const getters = {};

const actions = {
    async fetchMarketData({ commit }) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query getMarkets {
                        getMarkets  {
                            marketId
                            name
                            description
                            isActive
                        }
                    }
                `
            });

            commit('setMarketData', response.data.getMarkets);
        } catch (error) {
            console.error('Error while fetching market data:', error);
        }
    },
};

const mutations = {
    setMarketData(state, marketData) {
        state.marketData = marketData;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
